import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';
import { IMatchPaymentsSelector, ITeamsSelector, ICartSelector } from 'app/types/selector';

import matchPaymentsActions from 'app/ducks/matchPayments/actions';
import cartActions from 'app/ducks/cart/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as matchPaymentsSelectors from 'app/ducks/matchPayments/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';
import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import * as cartSelectors from 'app/ducks/cart/selectors';

import CartBasicComponent from './CartBasicComponent';

//
function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    matchPayments: matchPaymentsSelectors.getMatchPayments(
      state,
    ),
    cart: cartSelectors.getCart(state),
    teams: teamsSelectors.getTeams(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(matchPaymentsActions, cartActions);

interface ICartBasicProps {
  matchPayments: IMatchPaymentsSelector;
  teams: ITeamsSelector;
  cart: ICartSelector;
  match: any;
  actions: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class CartBasic extends React.Component<ICartBasicProps, {}> {
  static defaultProps: ICartBasicProps = {
    matchPayments: {},
    teams: {},
    cart: {},
    match: undefined,
    actions: undefined,
  };

  componentDidMount = () => {
    this.props.actions.resetCart({ defaultLoaded: false });
  };

  componentDidUpdate = () => {
    const { currentMatchPayment } = this.props.matchPayments;
    if (!this.props.cart.defaultLoaded) {
      this.compileLineItems(currentMatchPayment);
    }
  }

  compileLineItems = (currentMatchPayment) => {
    const lineItems: any = {};
    if (currentMatchPayment.paymentType === 'event') {
      lineItems.matchPayment = {
        amount: currentMatchPayment.amount,
        description: currentMatchPayment.description,
        quantity: 1,
        code: 'match_payment',
      };
      this.props.actions.updateCart({ defaultLoaded: true, lineItems });
    }
    return lineItems;
  };

  render(): React.ReactNode {
    const { currentMatchPayment } = this.props.matchPayments;
    if (!_.isEmpty(currentMatchPayment)) {
      const { fixtureMatch } = currentMatchPayment;
      if (!_.isEmpty(fixtureMatch)) {
        return (
          <CartBasicComponent
            matchCardData={paymentEventsSelectors.getPaymentEventForMatchCard(
              fixtureMatch,
              currentMatchPayment.group.id,
            )}
            groupName={paymentEventsSelectors.getGroupName(
              fixtureMatch,
              currentMatchPayment.group.id,
            )}
            matchPaymentId={this.props.match.params.matchPaymentId}
            totalAmount={this.props.cart.totalAmount}
            lineItems={this.props.cart.lineItems}
          />
        );
      }
    }
    return null;
  }
}
